import { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import "./Login.css";
import { Link } from "react-router-dom";
import logo from "../Navbar/logo.png";
import LoginService from "../../services/LoginServices";

export default function Register() {
  const [namesurname, setNameSurname] = useState();
  const [phone, setPhone] = useState();
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [repassword, setRePassword] = useState();
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    if (password != repassword) {
      setMessage("Passwords should match");
      return;
    }

    const user = await LoginService.register(
      username,
      password,
      namesurname,
      phone,
      ""
    ).catch((err) => {
      setMessage("Unknown error please try later.");
    });
    if (user.Request == 3) {
      setMessage(
        "Please check your email in order to continueu registration process."
      );
      //  redirect("/");
    } else if (user.Request == 2) {
      setMessage(
        "Email already registered. Please go to your email and complete approval process."
      );
    } else if (user.Request == 1) {
      setMessage(
        "Your registration approval is pending. Please wait until we contact you."
      );
    } else if (user.Request == 0) {
      setMessage("Email is already registered. Please use login page.");
    } else {
      setMessage("Unknown error please try later.");
    }
  };
  return (
    <div>
      <div className="container">
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100vh" }}
        >
          <div className="col-md-6">
            <Form onSubmit={handleSubmit}>
              <div className="px-3">
                <div className="vstack">
                  <img
                    src={logo}
                    width="30%"
                    style={{ alignSelf: "center" }}
                    alt="Orthomagic Logo"
                  />
                  <h3 className="text-center">Register New Doctor</h3>
                </div>

                <Form.FloatingLabel
                  className="mb-3"
                  label="Doctor Name"
                  controlId="firstname"
                >
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    onChange={(e) => setNameSurname(e.target.value)}
                  />
                </Form.FloatingLabel>

                <Form.FloatingLabel
                  className="mb-3"
                  label="Phone"
                  controlId="phone"
                >
                  <Form.Control
                    type="phone"
                    placeholder="Phone"
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </Form.FloatingLabel>

                <Form.FloatingLabel
                  className="mb-3"
                  label="Email"
                  controlId="username"
                >
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </Form.FloatingLabel>
                <Form.FloatingLabel
                  className="mb-3"
                  label="Password"
                  controlId="password"
                >
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Form.FloatingLabel>
                <Form.FloatingLabel
                  className="mb-3"
                  label="Confirm Password"
                  controlId="repassword"
                >
                  <Form.Control
                    type="password"
                    placeholder="Confirm Password"
                    onChange={(e) => setRePassword(e.target.value)}
                  />
                </Form.FloatingLabel>
                <Button className="w-100" variant="primary" type="submit">
                  Register
                </Button>
                <text className="text-center">
                  {" "}
                  Go back to <Link to="/login"> Login Page </Link>
                </text>
                {message && (
                  <div className="my-3 text-center rounded py-2 bg-danger text-white">
                    {message}
                  </div>
                )}
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
